import { BooleanInput, Create, SimpleForm, TextInput } from "react-admin";

export const YoutubeVideoCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <BooleanInput source="isActive" />
        <TextInput source="title" />
        <TextInput source="thumbnailUrl" />
        <TextInput source="youtubeUrl" />
      </SimpleForm>
    </Create>
  );
};
